<template>
  <div class="mt-1" v-loading="loadingData">
    <div class="nurseOffice">
      <!-- <div class="mt10 mb-3">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/hospital' }">Cтационар</el-breadcrumb-item>
          <el-breadcrumb-item>Кабинет медсестра</el-breadcrumb-item>
        </el-breadcrumb>
      </div>-->
      <div class="title_resultsPatsnt">
        <div class="title_resultsPatsnt_text">{{ $t('message.patient_physiotherapy') }}</div>
        <el-button :disabled="lastHistory.is_ended != 0" v-can="'physiotherapies.create'" size="mini" @click="drawer.create.status = true"
          icon="el-icon-circle-plus-outline">
          {{ $t('message.add_physiotherapy') }}
        </el-button>
      </div>
      <div class="nurseOffice_tabs overflow-hidden pl-4 pr-4">
        <Medicine />
      </div>

    </div>

    <el-drawer size="100%" :wrapperClosable="false" :visible.sync="drawer.create.status" :ref="drawer.create.name"
      @opened="drawerOpened(drawer.create.component)" @closed="drawerClosed(drawer.create.component)">
      <crm-create :ref="drawer.create.component" :drawer-name="drawer.create.name"></crm-create>
    </el-drawer>
  </div>
</template>
<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
  import CrmCreate from "./components/addPhys";
  import list from "@/utils/mixins/list";
  import Medicine from "./components/physiotherapyMedicine";
  import drawer from "@/utils/mixins/drawer";

  export default {
    mixins: [list, drawer],
    name: "physiotherapy",
    components: {
      Medicine,
      CrmCreate
    },
    data() {
      return {
        loadingData: false,
        selectedModel: {},
        drawer: {
          create: {
            name: "create",
            status: false,
            component: 'componentDrawerCreate'
          }
        }
      }
    },
    computed: {
      getId() {
        return this.$route.params.id;
      },
      ...mapGetters({
        activeCode: 'patients/activeCode',
        list: 'physiotherapies/list',
        columns: "physiotherapies/columns",
        pagination: "physiotherapies/pagination",
        filter: "physiotherapies/filter",
        sort: "physiotherapies/sort",
        physiotherapy: 'physiotherapies/model',
        lastHistory: 'patientHistories/model',
      }),
      actions: function () {
        return ['edit', 'delete'];
      }
    },
    watch: {
      lastHistory: {
        handler: function (val, oldVal) {
          this.updateList({
              patient_id: val.patient_id,
              id: this.getId
            })
            .then(res => {
            }).catch(err => {
              this.$notify({
                title: "Ошибка",
                type: "error",
                offset: 130,
                message: err.error.message,
              })
            });
        }
      },
    },
    async mounted() {
      if (!this.lastHistory || this.lastHistory.id !== "") {
        await this.getLastHistory({id: this.getId});
      }
    },
    methods: {
      ...mapActions({
        updateList: 'physiotherapies/index',
        updateSort: "physiotherapies/updateSort",
        updateFilter: "physiotherapies/updateFilter",
        updateColumn: "physiotherapies/updateColumn",
        updatePagination: "physiotherapies/updatePagination",
        editModel: 'physiotherapies/show',
        empty: 'physiotherapies/empty',
        delete: 'physiotherapies/destroy',
        refreshData: 'physiotherapies/refreshData',
        getLastHistory: "patientHistories/show",
      }),
      fetchData() {
        if ((_.isArray(this.lastHistory) && this.lastHistory.length > 0) || this.lastHistory.id) {
            this.loadingData = true;
          this.updateList({
              patient_id: this.lastHistory.patient_id,
              id: this.getId
            })
            .then(res => {
              this.loadingData = false;
            }).catch(err => {
              this.loadingData = false;
              this.$notify({
                title: "Ошибка",
                type: "error",
                offset: 130,
                message: err.error.message,
              })
            });
        }

      },
      refresh() {
        this.refreshData()
          .then(res => {
            this.filterForm = JSON.parse(JSON.stringify(this.filter));
          })
          .catch(err => {

          })
      },
      destroy(model) {
        this.delete(model.id)
          .then(res => {
            this.$notify({
              title: 'Успешно',
              type: "success",
              offset: 130,
              message: res.message
            });
            this.fetchData()
          })
          .catch(err => {
            console.log(err)
          })
      },
      emptyModel() {
        this.empty()
      },
    }
  };
</script>